/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SpacerBlock from "../spacerBlock/SpacerBlock";
import noImg from './img/noImg.png'

export default class ManuscriptPoolItem extends Component {
    static defaultProps = {
        title: '校长邱勇：秉持科教融合核心理念 培养高层次拔尖创新人才校长邱勇：秉持科教融新人才校长邱勇：秉持科教融新人才校长邱勇：秉持科教融合核心理念 培养高层次拔尖创新人才',
        newSecondSelectColor:'#0050B3'
    };
    static propTypes = {
        title: PropTypes.string.isRequired,//标题
        submitTime: PropTypes.string.isRequired,//发布时间
        mark: PropTypes.string.isRequired,//描述
        submitStatusName:PropTypes.string.isRequired,//发布状态
        name: PropTypes.string.isRequired,//发布人姓名
        titlePic: PropTypes.string.isRequired,//标题图
        task1: PropTypes.string,//关联任务
        task2: PropTypes.string,//关联选题
        titleClick: PropTypes.func,//标题店家
        task1Click: PropTypes.func,//任务一点击
        task2Click: PropTypes.func,//任务2点击
        createTime: PropTypes.string.isRequired,//创建时间
        changeTime:PropTypes.string.isRequired,//创建时间
        userPic:PropTypes.string.isRequired,//用户头像
        content:PropTypes.string,//内容
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let newSecondSelectColor = this.props.newSecondSelectColor ? this.props.newSecondSelectColor : '#0050B3';
        let showContentText = "";
        if(this.props.content){
            showContentText=this.props.content.replace(/<[^>]*>/ig,"");
        };
        return (
            <div>
                <div className={'poolItem'}>
                    <div style={{padding: 20}}>
                        <div style={{display: 'flex'}}>
                            <div className={'mouseHover'} style={{
                                fontSize: 18, overflow: 'hidden', position: 'relative',
                                textOverflow: 'ellipsis', color: '#2a3a6b', width: '80%',
                                whiteSpace: 'nowrap', fontWeight: 'bold'
                            }} title={this.props.title} onClick={() => {
                                this.props.titleClick && this.props.titleClick()
                            }}>{this.props.title}
                            </div>
                            <div style={{
                                width: '20%',
                                textAlign: 'right',
                                color: '#8792b3',
                                lineHeight: '30px',
                                fontWeight: 'bold',
                                fontSize: 15,
                            }}>
                                <span>{this.props.submitStatusName} &nbsp;</span>
                                {this.props.usingName?'(' :''} {this.props.usingName?this.props.usingName:''}{this.props.usingName?')' :''}
                                <span style={{fontWeight: 'normal'}}>{this.props.submitTime}</span>
                            </div>
                        </div>
                        <div style={{display: 'flex', marginTop: 20, marginBottom: 20}}>
                            <div style={{width: '80%'}}>
                                <div style={{
                                    position: 'relative',
                                    width: '100%',
                                    color: '#a4adc8',
                                    height: 48,
                                    wordWrap: "break-word",
                                    wordBreak: "normal",
                                    fontSize: 15,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical'
                                }} title={
                                        this.props.mark===""?showContentText:this.props.mark                               
                                    }>
                                    {this.props.mark===""?showContentText:this.props.mark }
                                </div>
                                <div style={{display: 'flex', marginTop: 15}}>
                                    {this.props.task1 ? <div onClick={() => {
                                        this.props.task1Click && this.props.task1Click()
                                    }} className={'mouseHover'} style={{
                                        background: '#f4f6fc',
                                        padding: 5,
                                        color: '#8792b3',
                                        fontSize: 14,
                                        borderRadius: 4,
                                        fontWeight: 'bold'
                                    }}>关联任务:{this.props.task1}</div> : null}
                                    {this.props.task2 ? <div className={'mouseHover'} onClick={() => {
                                        this.props.task2Click && this.props.task2Click()
                                    }} style={{
                                        background: '#f4f6fc',
                                        marginLeft: this.props.task1?10:0,
                                        padding: 5,
                                        color: '#8792b3',
                                        fontSize: 14,
                                        borderRadius: 4,
                                        fontWeight: 'bold'
                                    }}>关联选题:{this.props.task2}</div> : null}
                                </div>
                                <style>
                                    {`
                                            .mouseHover:hover {
                color: ${newSecondSelectColor} !important;
                cursor:pointer
            }
                                            `}</style>
                            </div>
                            < div style={{width: '20%', textAlign: 'right', color: '#8792b3', lineHeight: '30px'}}>
                                <img src={this.props.titlePic?this.props.titlePic:noImg} style={{width: 120, height: 90}} alt=""/>
                            </div>
                        </div>
                        <SpacerBlock height={1}/>
                        <div style={{display: 'flex', paddingTop: 20,}}>
                            <div><img style={{width: 24, height: 24,borderRadius:'50%'}} src={this.props.userPic} alt=""/></div>
                            <div style={{fontSize: 15, color: '#8792b3', marginLeft: 10}}><span><b>{this.props.name}</b></span><span
                                style={{marginLeft: 20}}>创建于{this.props.createTime}</span><span
                                style={{marginLeft: 20}}>修改于{this.props.changeTime}</span></div>
                            <div style={{width:'75%',textAlign:'right',position:'absolute',right:10}}>
                                {this.props.btn}
                            </div>
                        </div>
                    </div>
                    <SpacerBlock height={10}/>
                </div>
            </div>
        )
    }

}